import { useWizard } from '../wizardContext';
import { fmtBRL } from '../utils/finance';
import { RichSelect } from '../parts/RichSelect';

export const Step1Modelo = () => {
  const { state, set, vehicles, units, model, minVersionPrice, next, renderImage } = useWizard();

  const selectModel = (id: string) =>
    set((d) => {
      if (d.vehicle.modelId !== id) {
        d.vehicle.modelId = id;
        d.vehicle.versionId = null;
        d.vehicle.price = 0;
      }
    });

  const selectVersion = (id: string) =>
    set((d) => {
      const m = vehicles.find((v) => v.id === d.vehicle.modelId);
      const vr = m?.versions.find((x) => x.id === id);
      d.vehicle.versionId = id;
      d.vehicle.price = vr ? vr.price : 0;
    });

  // Unidade só é obrigatória quando o canal tem unidades cadastradas; sem
  // unidades, a etapa mostra empty state e não bloqueia o avanço.
  const hasUnits = units.length > 0;
  const valid = !!(state.vehicle.modelId && state.vehicle.versionId && (!hasUnits || state.vehicle.unitId));

  return (
    <div className="lpfs-anim-in">
      <div className="lpfs-step-head">
        <h2 className="lpfs-step-title">Escolha seu modelo</h2>
        <p className="lpfs-step-sub">Selecione o modelo, a versão e a unidade que deseja negociar.</p>
      </div>

      <div className="lpfs-fieldset">
        <p className="lpfs-section-label">Modelo</p>
        <RichSelect
          ariaLabel="Modelo"
          value={state.vehicle.modelId || ''}
          onChange={selectModel}
          renderImage={renderImage}
          options={vehicles.map((m) => ({
            value: m.id,
            label: m.name,
            description: `A partir de ${fmtBRL(minVersionPrice(m))}`,
            imageSrc: m.image || undefined,
            imageKind: 'thumb',
          }))}
        />
      </div>

      {model && (
        <div className="lpfs-fieldset">
          <p className="lpfs-section-label">Versão</p>
          <RichSelect
            ariaLabel="Versão"
            value={state.vehicle.versionId || ''}
            onChange={selectVersion}
            renderImage={renderImage}
            options={model.versions.map((vr) => ({
              value: vr.id,
              label: vr.name,
              description: fmtBRL(vr.price),
              imageSrc: vr.image || undefined,
              imageKind: 'thumb',
            }))}
          />
        </div>
      )}

      <div className="lpfs-fieldset">
        <p className="lpfs-section-label">Unidade</p>
        {hasUnits ? (
          <RichSelect
            ariaLabel="Unidade"
            value={state.vehicle.unitId}
            onChange={(id) => set((d) => { d.vehicle.unitId = id; })}
            options={units.map((u) => ({
              value: u.id,
              label: u.name,
              description: u.address || undefined,
            }))}
          />
        ) : (
          <p style={{ margin: 0, fontSize: 14, color: 'var(--lpfs-muted)' }}>
            Nenhuma unidade cadastrada para este site.
          </p>
        )}
      </div>

      <div className="lpfs-actions">
        <span className="lpfs-spacer" />
        <button type="button" className="lpfs-btn lpfs-btn-primary" disabled={!valid} onClick={next}>
          Continuar
        </button>
      </div>
    </div>
  );
};
